import { render } from "./snsEdit.vue?vue&type=template&id=3448a60a&scoped=true"
import script from "./snsEdit.vue?vue&type=script&lang=js"
export * from "./snsEdit.vue?vue&type=script&lang=js"

import "./snsEdit.vue?vue&type=style&index=0&id=3448a60a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3448a60a"]])

export default __exports__